const accessLevelsNumeric: { [key: string]: number } = {
    "employee": 0,
    "engineer": 500,
    "engineerplus": 750,
    "admin": 1000,
};

export type UserAccessLevel = "admin" | "engineerplus" |"Engineer" | "employee";

export const userAccessLevelIsAtLeast = (levelToCheckAgainst: UserAccessLevel, levelToCheck?: UserAccessLevel) => {
    if (levelToCheck == undefined) {
        return false
    }
    return accessLevelsNumeric[levelToCheck.toLowerCase()] >= accessLevelsNumeric[levelToCheckAgainst.toLowerCase()];
}

export default interface UserAccessRecord {
    [key: string]: string | undefined;

    userOid?: string;
    level?: UserAccessLevel
}